export default {
  props: {
    desc: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      descriptionShowPr: 0,
      descriptionShowQa: 0,
    };
  },
};
